<template>
  <div class="section section_no-padding-bottom">
    <div class="final">
      <div class="max-width">
        <div class="section__head section__head_middle">
          <div class="section__subheading fadeIn">Boost Sales</div>
          <h2 class="section__title">with Engaging Themes</h2>
          <div class="section__text">Drive more sales with themes designed for speed, usability, and higher conversions.</div>
          <div class="section__buttons">
            <router-link to="/themes" class="button">
              Explore Themes
              <IconArrow />
            </router-link>
          </div>
        </div>
      </div>

      <div class="final__slider">
        <div class="scroll-banner">
          <div class="scroll-banner__track">
            <img loading="lazy" srcset="/assets/imgs/themes/zap/final@2x.webp 2x, /assets/imgs/themes/zap/final.webp 1x" src="/assets/imgs/themes/zap/final@2x.webp" alt="Megastore Shopify theme final checkout and UI design" />
            <img loading="lazy" srcset="/assets/imgs/themes/zap/final@2x.webp 2x, /assets/imgs/themes/zap/final.webp 1x" src="/assets/imgs/themes/zap/final@2x.webp" alt="Megastore Shopify theme final checkout and UI design" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .final {
    background:url('@/assets/imgs/final-bg.png') no-repeat 50% 100%;
    background-size:contain;

    @include xxl {
      background-size:2000px;
    }

    @include md {
      background-size:1150px;
    }

    .section__head {
      max-width:800px;
      margin-bottom:12rem;

      @include md {
        margin-bottom:7rem;
      }
    }

    &__slider {
      img {
        filter: drop-shadow(0 0 24px rgba(127, 127, 127, 0.1));
      }

      .scroll-banner {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: auto;
        --image-width: 1956px;
        --scroll-speed:40s;
        padding:2.5rem 0 4rem;
        margin:-3rem 0 0;

        @include md {
          --image-width: 1000px;
        }

        &__track {
          display: flex;
          width: calc(var(--image-width) * 2);
          animation: scroll-x linear infinite;
          animation-duration: var(--scroll-speed);
          gap:1.5rem;

          img {
            width: var(--image-width);
            height: auto;
            flex-shrink: 0;
            object-fit: cover;
            -webkit-user-drag: none;
            user-select: none;
            pointer-events: none;
          }
        }
      }

      @keyframes scroll-x {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(calc(-50% - 1.5rem));
        }
      }
    }
  }
</style>

<script setup>
  import IconArrow from "@/components/icons/IconArrow.vue";
</script>
